import React from "react";
import { Helmet } from "react-helmet";

export type MetaDataProps = {
  title: string;
  link?: string;
  description?: string;
  image?: string;
};
export const MetaData = ({ title, link, description, image }: MetaDataProps) => (
  <Helmet>
    <meta charSet="utf-8" />
    <title>{title}</title>
    <link rel="canonical" href={link} />
    <meta name="description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:image" content={image} />
  </Helmet>
);

export default MetaData;
